import { render, staticRenderFns } from "./m-list.vue?vue&type=template&id=2465da8e&scoped=true&"
import script from "./m-list.vue?vue&type=script&lang=js&"
export * from "./m-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2465da8e",
  null
  
)

export default component.exports